import { render, staticRenderFns } from "./health_doc.vue?vue&type=template&id=64087e2e&"
import script from "./health_doc.vue?vue&type=script&lang=js&"
export * from "./health_doc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports